<template>
  <div id="map" style="height: 400px;"></div>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import Axios from '../../Axios';
// Import your custom marker icon image
import customMarkerIcon from '../../assets/images/mark.png'; // Adjust the path accordingly

export default {
  data() {
    return {
      map: null,
      latitude: null,
      longitude: null,
    };
  },
  mounted() {
    // Make an HTTP request to fetch latitude and longitude from the API
    Axios.get('/generalSetting/')
      .then((response) => {
        // console.log(response.data);
        const { mapLocation } = response.data;
        this.latitude = mapLocation.latitude;
        this.longitude = mapLocation.longitude;

        // Initialize the map with dynamic coordinates
        this.map = L.map('map').setView([this.latitude, this.longitude], 13);

        // Add a tile layer (you can use different map providers)
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(this.map);

        // Define a custom marker icon
        const customIcon = L.icon({
          iconUrl: customMarkerIcon,
          iconSize: [32, 32], // Set the size of your custom marker icon
          iconAnchor: [16, 32], // Set the anchor point of the icon
          popupAnchor: [0, -32], // Set the popup anchor point
        });

        // Add a marker with the custom icon
        L.marker([this.latitude, this.longitude], { icon: customIcon }).addTo(this.map)
          .bindPopup('الفرسان | AlFursan')
          .openPopup();
      })
      .catch((error) => {
        // console.error('Error fetching data from the API:', error);
      });
  },
};
</script>

<style scoped>
#map {
  width: 100%;
}
</style>
